import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VoceClassificaDTO } from "@app/shared/dto/voce-classificaDTO";
import { VoceClassificaVO } from "@app/shared/vo/voce-classificaVO";
import { MapperStruttura } from "@app/shared/mapper/mapper-struttura";
import { MapperVoceCorrelataClassifica } from "@app/shared/mapper/mapper-voce-correlata-classifica";
import { env } from "@env/environment";
import { MapperTipologiaFascicoloCorrelata } from "./mapper-tipologia-fascicolo-correlata";
import { MapperVersioneFutura } from "./mapper-versione-futura";

@Injectable({
  providedIn: "root"
})
export class MapperVoceClassifica
  implements MapperInterface<VoceClassificaDTO, VoceClassificaVO> {
  constructor(
    private mapperStruttura: MapperStruttura,
    private mapperVoceCorrelataClassifica: MapperVoceCorrelataClassifica,
    private mapperTipologiaFascicoloCorrelata: MapperTipologiaFascicoloCorrelata,
    private mapperVersioneFutura: MapperVersioneFutura
  ) {}

  convertVoToDto(vo: VoceClassificaVO): VoceClassificaDTO {
    if (vo != null) {
      const dto = new VoceClassificaDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.id = vo.id;
      // ente da file di properties
      dto.ente = env.ente;
      dto.codice = vo.codice;
      dto.nome = vo.nome;
      dto.descrizione = vo.descrizione;
      dto.dataCreazione = vo.dataCreazione;
      dto.dataModifica = vo.dataModifica;
      dto.dataInizioValidita = vo.dataInizioValidita;
      dto.dataFineValidita = vo.dataFineValidita;
      dto.riferimentiNormativi = vo.riferimentiNormativi;
      dto.vociCorrelate = this.mapperVoceCorrelataClassifica.convertListVoToDto(
        vo.vociCorrelate
      );
      dto.struttureCollegate = this.mapperStruttura.convertListVoToDto(
        vo.struttureCollegate
      );
      dto.struttureProprietarie = this.mapperStruttura.convertListVoToDto(
        vo.struttureProprietarie
      );
      dto.tipologieFascicolo = this.mapperTipologiaFascicoloCorrelata.convertListVoToDto(vo.tipologieFascicolo);
      dto.abilitaInvioComunicazioniDipendenti = vo.abilitaInvioComunicazioniDipendenti;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: VoceClassificaDTO): VoceClassificaVO {
    if (dto != null) {
      const vo = new VoceClassificaVO();
      vo.id = dto.id;
      vo.ente = dto.ente;
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.descrizione = dto.descrizione;
      vo.dataCreazione = dto.dataCreazione;
      vo.dataModifica = dto.dataModifica;
      vo.dataInizioValidita = dto.dataInizioValidita;
      vo.dataFineValidita = dto.dataFineValidita;
      vo.riferimentiNormativi = dto.riferimentiNormativi;
      vo.vociCorrelate = this.mapperVoceCorrelataClassifica.convertListDtoToVo(
        dto.vociCorrelate
      );
      vo.struttureCollegate = this.mapperStruttura.convertListDtoToVo(
        dto.struttureCollegate
      );
      vo.struttureProprietarie = this.mapperStruttura.convertListDtoToVo(
        dto.struttureProprietarie
      );
      vo.tipologieFascicolo = this.mapperTipologiaFascicoloCorrelata.convertListDtoToVo(dto.tipologieFascicolo);
      vo.output = vo.codice + " - " + vo.nome;
      vo.countChildren = dto.countChildren;
      vo.cancellata = dto.cancellata;
      vo.versioneFutura = this.mapperVersioneFutura.convertDtoToVo(dto.versioneFutura);
      vo.abilitaInvioComunicazioniDipendenti = dto.abilitaInvioComunicazioniDipendenti;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: VoceClassificaVO[]): VoceClassificaDTO[] {
    if (voList != null) {
      return voList.map(vo => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: VoceClassificaDTO[]): VoceClassificaVO[] {
    if (dtoList != null) {
      let array: VoceClassificaVO[];
      array = dtoList.map(dto => this.convertDtoToVo(dto));
      return array;
    } else {
      return null;
    }
  }
}
